// extracted by mini-css-extract-plugin
export default {"tupacGrid":"Il-z","tupacHeader":"Jl-z","tupacHeader2":"Kl-z","tupacMenu":"Ll-z","tupacMenu2":"Ml-z","tupacMain":"Nl-z","tupacMain2":"Ol-z"};